__turbopack_context__.v({
  "backdrop": "SearchModal-module__zYUmpW__backdrop",
  "panel": "SearchModal-module__zYUmpW__panel",
});
